export default __webpack_public_path__ + "static/media/TAANI_STORE._compressed.4edbd8b7.pdf";